import { definePreset } from '@primevue/themes';
import { BebawaPreset } from '@peanuds/app-shell/plugins/prime-vue';

export const bebawaPrimeVuePreset = definePreset(BebawaPreset, {
  semantic: {
    formField: {
      paddingX: 'var(--customer-form-field-padding-x, 0.75rem)',
      paddingY: 'var(--customer-form-field-padding-y, 0.5rem)',
      borderRadius: 'var(--customer-form-field-border-radius, var(--p-border-radius-md))',
      transitionDuration: 'var(--customer-form-field-transition-duration, 0.2s)',
    },
    overlay: {
      select: {
        borderRadius:
          'var(--customer-dropdown-overlay-border-radius, var(--customer-form-field-border-radius, var(--p-border-radius-md)))',
        shadow:
          'var(--customer-dropdown-overlay-shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1))',
      },
    },
    list: {
      padding: 'var(--customer-dropdown-list-padding, 0.25rem 0.25rem)',
      gap: 'var(--customer-dropdown-list-gap, 2px)',
      option: {
        padding: 'var(--customer-dropdown-option-padding, 0.5rem 0.75rem)',
        borderRadius: 'var(--customer-dropdown-option-border-radius, var(--p-border-radius-sm))',
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: 'var(--customer-button-border-radius, var(--p-border-radius-absolut))',
        roundedBorderRadius:
          'var(--customer-button-rounded-border-radius, var(--customer-button-border-radius, var(--p-border-radius-absolut)))',
        gap: 'var(--customer-button-gap, 0.4375rem)',
        paddingX: 'var(--customer-button-padding-x, 0.765625rem)',
        paddingY: 'var(--customer-button-padding-y, 0.546875rem)',
        label: {
          fontWeight: 'var(--customer-button-label-font-weight, 500)',
        },
      },
    },
    select: {
      css: `
        .p-select {
          height: var(--customer-select-height, 2.5rem);
          min-height: var(--customer-select-min-height, 2.5rem);
          font-size: var(--customer-select-font-size, 0.875rem);
          font-weight: var(--customer-select-font-weight, 500);
        }

        .p-select .p-select-label {
          display: flex;
          align-items: center;
          padding: var(--customer-select-label-padding, var(--customer-select-padding-y, 0.5rem) var(--customer-select-padding-x, 0.75rem));
          line-height: var(--customer-select-line-height, 1.25rem);
        }

        .p-select .p-select-dropdown {
          border-radius: var(--customer-select-dropdown-border-radius, 0 var(--customer-select-border-radius, var(--p-border-radius-md)) var(--customer-select-border-radius, var(--p-border-radius-md)) 0);
          background: var(--customer-select-dropdown-background, var(--p-surface-300));
          border: var(--customer-select-dropdown-border, none);
          color: var(--customer-select-dropdown-color, var(--p-surface-600));
        }
      `,
      root: {
        background: 'var(--customer-select-background, var(--p-surface-0))',
        borderColor: 'var(--customer-select-border-color, var(--p-surface-200))',
        hoverBorderColor: 'var(--customer-select-hover-border-color, var(--p-surface-300))',
        focusBorderColor: 'var(--customer-select-focus-border-color, var(--p-primary-500))',
        color: 'var(--customer-select-color, var(--p-surface-700))',
        placeholderColor: 'var(--customer-select-placeholder-color, var(--p-surface-500))',
        shadow: 'var(--customer-select-shadow, none)',
        paddingX: 'var(--customer-select-padding-x, var(--customer-form-field-padding-x, 0.75rem))',
        paddingY: 'var(--customer-select-padding-y, var(--customer-form-field-padding-y, 0.5rem))',
        borderRadius: 'var(--customer-select-border-radius, var(--p-border-radius-lg))',
        transitionDuration:
          'var(--customer-select-transition-duration, var(--customer-form-field-transition-duration, 0.2s))',
      },
      dropdown: {
        width: 'var(--customer-select-dropdown-width, 2.5rem)',
        color: 'var(--customer-select-dropdown-color, var(--p-surface-600))',
      },
      overlay: {
        background: 'var(--customer-select-overlay-background, var(--p-surface-0))',
        borderColor: 'var(--customer-select-overlay-border-color, var(--p-surface-200))',
        borderRadius:
          'var(--customer-select-overlay-border-radius, var(--customer-dropdown-overlay-border-radius, var(--p-border-radius-md)))',
        color: 'var(--customer-select-overlay-color, var(--p-surface-700))',
        shadow:
          'var(--customer-select-overlay-shadow, var(--customer-dropdown-overlay-shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)))',
      },
      list: {
        padding:
          'var(--customer-select-list-padding, var(--customer-dropdown-list-padding, 0.25rem))',
        gap: 'var(--customer-select-list-gap, var(--customer-dropdown-list-gap, 2px))',
      },
      option: {
        padding:
          'var(--customer-select-option-padding, var(--customer-dropdown-option-padding, 0.5rem 0.75rem))',
        borderRadius:
          'var(--customer-select-option-border-radius, var(--customer-dropdown-option-border-radius, var(--p-border-radius-sm)))',
        color: 'var(--customer-select-option-color, var(--p-surface-700))',
        focusColor: 'var(--customer-select-option-focus-color, var(--p-surface-700))',
        focusBackground: 'var(--customer-select-option-focus-background, var(--p-surface-100))',
        selectedColor: 'var(--customer-select-option-selected-color, var(--p-primary-700))',
        selectedBackground:
          'var(--customer-select-option-selected-background, var(--p-primary-50))',
        selectedFocusColor:
          'var(--customer-select-option-selected-focus-color, var(--p-primary-700))',
        selectedFocusBackground:
          'var(--customer-select-option-selected-focus-background, var(--p-primary-100))',
      },
    },
  },
});

export default bebawaPrimeVuePreset;
